<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党建宣传</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="addWrap">
						<el-form 
							label-position="left"
							ref="dyfc" 
							:model="formData" 
							:rules="rules">
							<el-form-item class="form_item" label="组织简介" prop="content">
								<el-input
									:rows="7"
									style="width: 700px !important;"
									type="textarea"
									placeholder="组织简介"
									v-model="formData.content">
								</el-input>
							</el-form-item>
							<el-form-item class="form_item form_ups" label="上传材料:"  prop="">
								<div>
									<el-upload
										name="file"
										:data="{token:$store.state.user.userinfo.token}"
										:action="$uploadFile"
										:show-file-list="false"
										:on-success="success1"
										:on-progress="uploadProcess"
										:before-upload="limitFile">
										<el-button  type="primary">宣传材料</el-button>
									</el-upload>
									<div class="progress_bar" v-if="showProgress">
										<div class="progress">
											<div class="progress_item" :style="progress"></div>
										</div>
										<div class="words" :style="{color:progress.background}">{{uptext}}</div>
									</div>
									<div class="tishi">支持图片、mp4文件，大小不得超过200M</div>
								</div>
							</el-form-item>
							<div class="fileList" v-if="formData.files.length > 0">
								<div class="fileItem" :key="index" v-for="(item,index) in formData.files">
									<div class="fileIcon" v-if="item.bsid == 8"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 3"><img src="@/assets/images/videoBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 1"><img src="@/assets/images/pptBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 2"><img src="@/assets/images/imgbg.png" ></div>
									<div class="fileName">{{item.title}}</div>
									<div class="fileDel" title="删除" @click="delfile(index)"><i class="el-icon-delete"></i></div>
								</div>
							</div>
							<el-form-item class="form_item submits">
								<el-button type="primary" @click="submit()">发布</el-button>
								<el-button @click="$router.go(-1)">清空</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {djxc} from '@/axios'
	import {bsid} from '@/common/common.js'
	import {Message} from 'element-ui'
	let that;
	export default {
		data(){
			return{
				formData:{
					content:"",
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					files:[]
				},
				showProgress:false,
				imageUrl:"",
				rules:{
					content: [
						{ required: true, message: '请输入组织简介', trigger: 'blur' }
					],
				},
				progress:{
					width:0,
					background:"#bb0000"
				},
				uptext:"上传中，请稍后"
			}
		},
		created(){that = this;},
		mounted(){that.bindData()},
		methods:{
			submit(){
				// 保存
				that.$refs.dyfc.validate(valid => {
					if(valid){
						djxc.updatePropaganda(that.formData).then(res => {
							if(res.code == 200){
								that.bindData();
							}else{
								Message.error(res.msg)
							}
						})
					}
				})
			},
			bindData(){
				djxc.propagandaGet({
					user_id:that.formData.user_id,
					flag:that.formData.flag
				}).then(res => {
					if(res.code == 200){
						that.formData.files = res.data.files;
						that.formData.content = res.data.content;
					}
				})
			},
			//删除文件
			delfile(index){
				this.formData.files.splice(index,1);
			},
			// 上传封面图成功
			success(res, file) {
				if(res.code == 200){
					that.imageUrl = URL.createObjectURL(file.raw);
					that.isUploaded = "重新上传"
					that.formData.img = res.data.src
				}else{
					Message.error('上传失败，请检查文件或网络连接');
				}
			},
			// 上传文件成功
			success1(res, file) {
				let data = {
					bsid:bsid(res.data.src),
					title:res.data.title,
					ment_url:res.data.src,
				}
				if(res.code == 200){
					that.formData.files.push(data)
				}
			},
			uploadProcess(event, file, fileList) {
				that.showProgress = true
				that.progress.width = ((Math.floor(event.percent)/100)*200)+'px';
				if(Math.floor(event.percent) == 100){
					that.progress.background = 'rgb(103,194,58)'
					that.uptext = '上传成功'
				}
			},
			// 图片上传限制
			limitFile(file){
				var length = that.formData.files.length;
				var isJPG = file.type === 'image/jpeg' 
						|| file.type === 'image/png' 
						|| file.type === 'image/jpg' 
						|| file.type === 'image/gif' 
						|| file.type === 'video/mp4'
				var isLt2M = file.size / 1024 / 1024 < 200;
				if(length==3){
					Message.error('最多上传三个文件');
					return false;
				}
				if (!isJPG) {
					Message.error('请上传系统支持的文件格式');
					return false;
				}
				if (!isLt2M) {
					Message.error('上传文件大小不能超过 200MB!');
					return false;
				}
			},
		}
	}
</script>

<style lang="scss">
	.tishi{
		color: #838A9D;
		font-size: 14px;
		margin-left: 10px;
	}
	.submits{
		margin: 80px 0 0 70px;
	}
	
	.fileList{
		width: 400px;
		margin-left: 65px;
		max-height: 400px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin-bottom: 22px;
		overflow-y: scroll;
		box-sizing: border-box;
		.fileItem{
			width: 100%;
			border: 1px solid #ddd;
			padding: 10px 10px;
			height: 80px;
			margin-bottom: 15px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			.fileIcon{
				width: 50px;
				img{
					width: 100%;
				}
			}
			.fileName{
				margin-left: 10px;
				margin-right: 10px;
				width: 280px;
				line-height: 30px;
				height: 30px;
				overflow: hidden;
			}
			i{
				cursor: pointer;
			}
			i:hover{
				color: #BB0000;
			}
		}
	}
	.progress_bar{
		display: flex;
		align-items: center;
		.progress{
			position: relative;
			width: 200px;
			border-radius: 10px;
			background-color: #ededed;
			height: 5px;
			margin-right: 10px;
			.progress_item{
				position: absolute;
				left: 0;
				top: 0;
				height: 100%;
				border-radius: inherit;
			}
		}
		.words{
			color: #bb0000;
			font-size: 12px;
		}
	}
</style>
